module.exports = "<base href=\"/\">\n<alert></alert>\n<app-toolbar></app-toolbar>\n<router-outlet></router-outlet>\n"